import TicketDetailsDescription from './TicketDetailsDescription';

export default TicketDetailsDescription;
